import { render } from "./DADataTable.vue?vue&type=template&id=4d393028"
import script from "./DADataTable.vue?vue&type=script&lang=js"
export * from "./DADataTable.vue?vue&type=script&lang=js"

import "./DADataTable.vue?vue&type=style&index=0&id=4d393028&lang=scss"

import exportComponent from "../../../../../CASRA/saoil/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__